import React, { Component } from "react";
import PropTypes from 'prop-types'
import moment from 'moment'
import './note.scss'

function newDraft(user) {
  return {
    visibility: "Standard",
    noteDetail: "",
    userName: user.username,
  }

}

/**
 * renders a list of notes via NoteItem components. Applies edit permissions per note according to user prop
 * TODO some kind of note delete confirmation or undo button (or somewhere else?)
 */
export class Notes extends Component {

  static propTypes = {
    noteData: PropTypes.arrayOf(PropTypes.any),
    user: PropTypes.shape({
      userType: PropTypes.string,
      permissions: PropTypes.any,
      userId: PropTypes.string,
      username: PropTypes.string
    }).isRequired,
    onSave: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired
  }
  constructor(props) {
    super(props)
    this.state = {
      draft: newDraft(this.props.user),
      draftCount: 1
    }
  }

  onSaveDraft = (draft) => {
    this.props.onSave(draft)
    this.setState({ draftCount: this.state.draftCount + 1})
    this.onDeleteDraft()
  }

  onDeleteDraft = () => {
    this.setState({ draft: newDraft(this.props.user) })
  }

  render() {
    const {
      noteData,
      user,
      onSave,
      onDelete,
    } = this.props



    const isStandard = user.permissions.indexOf('NoteAdmin') === -1;
    return (
      <React.Fragment>
        {noteData
          .filter(note => note.visibility === 'Standard' || !isStandard)
          .map(note => {
            return (<NoteItem
              note={note}
              key={note._id}
              readOnly={note.userId !== user.userId}
              isStandard={isStandard}
              onSave={onSave}
              onDelete={() => onDelete(note)}
            />)
          })}
        <NoteItem key={this.state.draftCount} /*key to reset internal state of draft on add*/
                  draft note={this.state.draft} onSave={this.onSaveDraft} onDelete={this.onDeleteDraft} isStandard={isStandard}/>
      </React.Fragment>
    )
  }
}

/**
 * Renders a sticky note type view for a note.
 * Can enter an edit mode or delete the note
 * Can save, cancel
 */
export class NoteItem extends React.Component {

  static propTypes = {
    note: PropTypes.any.isRequired,
    readOnly: PropTypes.bool,
    isStandard: PropTypes.bool.isRequired,
    onSave: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    draft: PropTypes.bool
  }

  constructor(props) {
    super(props)
    this.state = {
      isEditing: props.draft,
      copy: {
        ...props.note
      },
      modal: null
    }
  }


  setEditing = (isEditing) => {
    if (!this.props.readOnly && !this.props.draft) {
      this.setState({ isEditing: isEditing })
    }
  }

  onUpdateNote = e => {
    this.setState({ copy: {...this.state.copy, noteDetail: e.target.value }})
  }

  setVisibility = e => {
    this.setState({ copy: {...this.state.copy, visibility: e.target.value }})
  }

  save = () => {
    if (this.state.copy.noteDetail) {
      this.setEditing(false)
      this.props.onSave({
        ...this.props.note,
        visibility: this.state.copy.visibility,
        noteDetail: this.state.copy.noteDetail
      })
    }
  }

  revert = () => {
    this.setEditing(false)
    this.setState({ copy: { ...this.props.note }})
  }

  edit = () => this.setEditing(true);

  render() {

    const {isEditing} = this.state;

    const note = this.props.note;
    const copy = this.state.copy;
    let noteName;
    if(note._id){
      if(note.firstName || note.lastName){
        noteName = `${note.firstName} ${note.lastName}`.trim();
      }
      if(noteName.length){
        noteName = `${noteName}, `;
      }
      noteName = `${noteName}${note.userName}`;
    }

    return (
      <div className="note-item" >
        <div style={{marginBottom: '4px' }}>
          <span className="note-item-date-added">{
            note.dateAdded ? moment(note.dateAdded).format('M/D/YY HH:mm a') : ''
          }</span> <span className="note-item-username">{
            noteName
        }</span>
        </div>
        {!isEditing ?
          <div className="note-item-note-detail"
               onClick={this.edit}>{copy.noteDetail}</div>
          : <div>
              <textarea
                placeholder="New Note ..."
                className="note-item-editing-note-detail"
                value={copy.noteDetail} onChange={this.onUpdateNote}/>
          </div>
        }
        {
          !this.props.readOnly &&
          <div className="clearfix note-item-toolbar">
            {
            !this.props.isStandard &&
            <span style={{display: 'inline-block'}} onClick={this.edit}>
             <span className="note-item-label" >Visibility</span>{!isEditing
              ? <span className="note-item-visibility">{note.visibility}</span>
              : <select className="note-item-editing-visibility" value={copy.visibility}
                        disabled={!isEditing}
                        onChange={this.setVisibility}>
                <option value="Standard">Standard</option>
                <option value="Admin">Admin</option>
              </select>
            }
            </span>
            }
            <span className="cm-toolbar pull-right">
              {
                !isEditing && <a className="cm-toolbar-item fas fa-edit" onClick={() => this.setEditing(true)}/>
              }
              {
                !isEditing && <a className="cm-toolbar-item fas fa-trash-alt" onClick={this.props.onDelete}/>
              }
              {
                isEditing && <a className="cm-toolbar-item fas fa-check-circle" onClick={this.save}/>
              }
              {
                isEditing && <a className="cm-toolbar-item fas fa-times-circle" onClick={this.revert}/>
              }

          </span>
          </div>
        }
      </div>
    )
  }
}



